import React from 'react';
import { Typography, Card, Image, Row, Col } from 'antd';
import './supplierHome/LoginOutlet.css'
import {  TEXT_CONSTANTS } from '../../constants/Constants';
import SupplierForm from '../Supplier/SupplierForm';
import loginImage from '../../assets/icons/loginImage.jpg'
import { Outlet } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const Signup = () => {
  return (
    <Row className="h-screen">

      <Col xs={24} lg={8} className="bg-[#1F405A] p-8 flex flex-col justify-center gap-4">
        <div>
          <Title style={{color:"white"}} className="text-[40px] lg:text-[50px] text-white">
            {TEXT_CONSTANTS.SUSTAINABILITY_PROGRAM_TITLE}
          </Title>
          <Paragraph className="text-white text-lg lg:text-xl">
            {TEXT_CONSTANTS.SUSTAINABILITY_PORTAL_DESCRIPTION}
          </Paragraph>
        </div>
        <div className="mt-auto flex justify-center">
          <Image
            src={loginImage}
            alt={TEXT_CONSTANTS.IMAGE_ALT_TEXT}
            className="w-[200px] lg:w-[300px] h-auto"
            preview={false}

          />
        </div>
      </Col>

      <Col xs={24} lg={16} className="bg-gray-100 flex items-center justify-center ">

          <SupplierForm/>
      </Col>
    </Row>
  );
};

export default Signup;